import * as StoreTypes from "../DataTypes/storeTypes";
import * as ActionGenerics from "../../../Common/actionGenerics";
import * as ActionTypes from "../Actions/actionTypes";

export const common = (
    state: StoreTypes.ICommon,
    action: ActionGenerics.IAction<ActionTypes.Actions>,
    initialSettings: StoreTypes.IInitialSettings
): StoreTypes.ICommon => {
    switch (action.type) {
        case ActionTypes.Actions.SetFormState: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, StoreTypes.FormState>;

            return { ...state, formState: data.parameter };
        }

        case ActionTypes.Actions.SetStatus: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, StoreTypes.LockStatus>;

            return { ...state, status: data.parameter };
        }

        case ActionTypes.Actions.SetIsBusy: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, boolean>;

            return { ...state, isBusy: data.parameter };
        }

        case ActionTypes.Actions.SetSubmitRequested: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, boolean>;

            return { ...state, submitRequested: data.parameter };
        }

        case ActionTypes.Actions.UpdateComposition: {
            const data = action as ActionGenerics.IParamAction<ActionTypes.Actions, any>;

            return { ...state, composition: data.parameter };
        }

        default:
            return state;
    }
};
